module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--6-862d9cd929b539220fe4b5501d5aa2c8.jpg";